import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { INTERACTION_DATE_LOOKBACK_DAYS } from "../constants";

interface DateFilterProps {
  selectedDate: Dayjs | null;
  onChange: (newValue: Dayjs | null) => void;
  disabled?: boolean;
}

export const DateFilter = ({ selectedDate, onChange, disabled = false }: DateFilterProps) => {
  const minAllowedDate = dayjs().subtract(INTERACTION_DATE_LOOKBACK_DAYS, "day").startOf("day");
  const maxAllowedDate = dayjs().endOf("day");

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label="Date"
        value={selectedDate}
        onChange={onChange}
        disabled={disabled}
        minDate={minAllowedDate}
        maxDate={maxAllowedDate}
        shouldDisableDate={(date) => {
          return date.isBefore(minAllowedDate) || date.isAfter(maxAllowedDate);
        }}
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            sx: {
              minWidth: { xs: "100%", sm: "100%", md: 180 },
              "& .MuiOutlinedInput-root": {
                bgcolor: "background.paper"
              }
            }
          }
        }}
      />
    </LocalizationProvider>
  );
};
